module.exports = __webpack_public_path__ + "img/info-02.e6fc68cf.jpg";